import React, { useState, useEffect, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { MMap } from 'src/components/M_Components'
import './formsTable.css'

export default function CreateAddress() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataAddress, setDataAddress] = useState(new Map())
    const [optionsAddress, setOptionsAddress] = useState([])
    const [addressId, setAddressId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServiceAddress = new BufferService('Address')
    const { t } = useTranslation()
    const [points, setPoints] = useState([])
    const sessionKeys = ['dataAddress', 'optionsAddress', 'addressId', 'operation']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id);
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataAddress, optionsAddress, addressId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDA = M_StateData.filter(obj => obj.key === `dataAddress`)[0]?.value
            const tempOA = M_StateData.filter(obj => obj.key === `optionsAddress`)[0]?.value
            const tempAI = M_StateData.filter(obj => obj.key === `addressId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempDA || tempOA || tempAI || tempOP) {
                setDataAddress(new Map(tempDA))
                setOptionsAddress(tempOA)
                setAddressId(tempAI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getAddress()
    }

    const getAddress = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setAddressId(getId)

        ctx.setIsLoad(true)
        bufferServiceAddress.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenList)
            setOptionsAddress(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceAddress.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataAddress = response
                    responseOptions.forEach(obj => {
                        dataAddress.set(obj.Name, valueDataAddress[obj.Name])
                    })
                    setPoints([
                        {
                            latitude: valueDataAddress.Latitude,
                            longitude: valueDataAddress.Longitude,
                        }
                    ])
                    setDataAddress(new Map(dataAddress))
                    ctx.setIsLoad(false)
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const addressStructure = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataAddress.set(index, dateValue)
        } else {
            dataAddress.set(index, event)
        }
        setDataAddress(new Map(dataAddress))
    }

    const submitAddress = () => {
        const latitude = points[0]?.latitude
        const longitude = points[0]?.longitude

        if (latitude === undefined || latitude === null || longitude === undefined || longitude === null) {
            ctx.toastMessages('error', '', t("RequiredReferencePoint"))
            return
        }

        dataAddress.set('Latitude', latitude)
        dataAddress.set('Longitude', longitude)
        const requiredFieldsPriceZone = optionsAddress.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsPriceZone) {
            if (!dataAddress.has(field.Name) || !dataAddress.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }
        ctx.setIsLoad(true)

        if (operation === 'edit') {
            bufferServiceAddress.update(addressId, Object.fromEntries(dataAddress)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceAddress.post(Object.fromEntries(dataAddress)).then((response) => {
                if (response.name === 'AxiosError') {
                    // if (response.response.data.Errors[0] === 'DuplicateZoneCode') {
                    //     ctx.toastMessages("error", '', t(response.response.data.Errors[0]))
                    //     ctx.setIsLoad(false)
                    //     return
                    // } else {
                        ctx.toastMessages("error", '', t("ErrorCreate"))
                        ctx.setIsLoad(false)
                        return
                    // }

                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitAddress}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divAlignFormPriceZone'>
                <div className='divFormPriceZone'>
                    {optionsAddress.map((elem) => (
                        <div key={elem.Name}>
                            {elem.Type === 'string' ? (
                                elem.IsForeignKey ? (
                                    <M_DrawerTableTextField
                                        tableLabel={elem.NormalizedName}
                                        label={elem.NormalizedName}
                                        required={elem.Required}
                                        entity={elem.ForeignTableName}
                                        value={dataAddress.get(elem.ForeignTableToPassId) ?
                                            {
                                                [elem.ForeignTableToPassId]: dataAddress.get(elem.ForeignTableToPassId),
                                                [elem.ForeignKeyName]: dataAddress.get(elem.Name)
                                            } : null}
                                        filterField={elem.ForeignKeyName}
                                        labelFields={[elem.ForeignKeyName]}
                                        onSubmitValue={obj => {
                                            if (obj) {
                                                dataAddress.set(elem.Name, obj[elem.ForeignKeyName])
                                                dataAddress.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                            } else {
                                                dataAddress.set(elem.Name, null)
                                                dataAddress.set(elem.ForeignTableToPassId, null)
                                            }
                                            setDataAddress(new Map(dataAddress))
                                        }}
                                        disabled={elem.disable}
                                        valueField={elem.ForeignTableToPassId}
                                    />
                                ) : (
                                    < M_InputTextField
                                        type={"text"}
                                        label={elem.NormalizedName}
                                        secondColor={"var(--color-red-dark)"}
                                        required={elem.IsRequired}
                                        onChange={(e) => addressStructure(e.target.value, elem.Name)}
                                        value={dataAddress.get(elem.Name) || ""}
                                    />
                                )
                            ) : elem.Type === 'int32' ? (
                                < M_InputTextField
                                    type={"number"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => addressStructure(e.target.value, elem.Name)}
                                    value={dataAddress.get(elem.Name) || ""}
                                />
                            ) : elem.Type === 'datetime' ? (
                                <M_InputTextField
                                    type={"date"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => addressStructure(e.target.value, elem.Name)}
                                    value={dataAddress.get(elem.Name) || ""}
                                />
                            ) : ""}
                        </div>
                    ))}
                </div>

                <div className='mapPriceZone'>
                    <h2>{t("DefineReferencePoint")}</h2>
                    <h5>{t("RequiredReferencePoint")}</h5>
                    <br />
                    <MMap
                        height={"450px"}
                        navigationControl
                        controlScale
                        fullscreen
                        findMyLoc
                        satelliteView
                        pointGet
                        numberGetPoints={1}
                        points={points}
                        setPoints={setPoints}
                    />
                </div>

            </div>
        </div>
    )
}
